import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const FilePDF: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      aria-hidden={!title}
      focusable='false'
      width={width}
      height={height}
      {...props}
    >
      <path
        d='M18 17V16H17V17H18ZM10.5 17V16H9.50002V17H10.5ZM10.5 23H9.50002V24H10.5V23ZM2 23V24H4V23H2ZM3 17V16H2V17H3ZM21 6H22V5.58579L21.7071 5.29289L21 6ZM16 1L16.7071 0.292893L16.4142 0H16V1ZM3 1V0H2V1H3ZM18 24H19V17H18H17V24H18ZM18 17V18H22V17V16H18V17ZM18 20.25V21.25H21.5V20.25V19.25H18V20.25ZM10.5 17H9.50002V23H10.5H11.5V17H10.5ZM10.5 23V24H13.625V23V22H10.5V23ZM13.625 23V24C14.6605 24 15.5 23.1605 15.5 22.125H14.5H13.5C13.5 22.0559 13.5559 22 13.625 22V23ZM14.5 22.125H15.5V17.875H14.5H13.5V22.125H14.5ZM14.5 17.875H15.5C15.5 16.8395 14.6605 16 13.625 16V17V18C13.5559 18 13.5 17.9441 13.5 17.875H14.5ZM13.625 17V16H10.5V17V18H13.625V17ZM3 23H4V20.5H3H2V23H3ZM3 20.5H4V17H3H2V20.5H3ZM3 17V18H6.125V17V16H3V17ZM6.125 17V18C6.05593 18 6 17.944 6 17.875H7H8C8 16.8396 7.16057 16 6.125 16V17ZM7 17.875H6V19.625H7H8V17.875H7ZM7 19.625H6C6 19.556 6.05593 19.5 6.125 19.5V20.5V21.5C7.16057 21.5 8 20.6604 8 19.625H7ZM6.125 20.5V19.5H3V20.5V21.5H6.125V20.5ZM21 14H22V6H21H20V14H21ZM21 6L21.7071 5.29289L16.7071 0.292893L16 1L15.2929 1.70711L20.2929 6.70711L21 6ZM16 1V0H3V1V2H16V1ZM3 1H2V14H3H4V1H3Z'
        fill={fill}
      />
    </svg>
  )
}

export default FilePDF
